(function() {

    var burger = document.querySelector('.burger');
    var burgerScnd = document.querySelector('.burger-second');

  if (burger) {

    var Menu = (function() {
      var menu = document.querySelector('.menu--mobile');
      var menuList = document.querySelector('.menu--mobile__list');
      var brand = document.querySelector('.menu--mobile__brand');
      var menuItems = document.querySelectorAll('.menu--mobile__item');
      var header = $('header');

      var active = false;

      var toggleMenu = function() {
        if (!active) {
          menu.classList.add('menu--mobile--active');
          menuList.classList.add('menu--mobile__list--active');
          brand.classList.add('menu--mobile__brand--active');
          burger.classList.add('burger--close');
          burgerScnd.classList.add('burger--close');
          header.addClass('activeTop');

          for (var i = 0, ii = menuItems.length; i < ii; i++) {
            menuItems[i].classList.add('menu--mobile__item--active');
          }

          active = true;
          $('body').addClass('unscroll');
        } else {
          menu.classList.remove('menu--mobile--active');
          menuList.classList.remove('menu--mobile__list--active');
          brand.classList.remove('menu--mobile__brand--active');
          burger.classList.remove('burger--close');
          burgerScnd.classList.remove('burger--close');
          header.removeClass('activeTop');
          for (var i = 0, ii = menuItems.length; i < ii; i++) {
            menuItems[i].classList.remove('menu--mobile__item--active');
          }

          active = false;
          $('body').removeClass('unscroll');
        }
      };

      var bindActions = function() {
        if($('.burger-second').length) {
          burger.addEventListener('click', toggleMenu, false);
        }

        if($('.burger-second').length) {
          burgerScnd.addEventListener('click', toggleMenu, false);
        }
      };

      var init = function() {
        bindActions();
      };

      return {
        init: init
      };

    }());
    if($('.burger').length || $('.burger-second').length) {
      Menu.init();
    }

  }

}());



// WEBPACK FOOTER //
// ./assets/js/menu-mobile.js